/**
 * Version 2.0
 * Vikas W
 * 03.05.2022
 * -
 * This component defines all the routes to the other pages
 */
import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import DashboardPage from './Pages/DashboardPage';

import Error404 from './Pages/404';
import Login from './Auth/Login';
import Register from './Auth/Register';
import ForgotPasswordPage from './Auth/ForgotPassword';
import ResetPasswordPage from './Auth/ResetPassword';
import MicrosoftPage from './Pages/Microsoft/Authentication';
// import ContactsOverview from './Pages/CRM/ContactOverview/index';
import ContactsOverview from './Pages/CRM/ContactOverview/index';
import ChangePassword from './Pages/MyAccount/ChangePassword/index';
import ConfirmVerifyEmail from './Auth/ConfirmVerifyEmail';
import NewSetPasswordPage from './Auth/NewSetPasswordPage';
import ConfirmUserEmail from './Auth/ConfirmUserEmail';
import InviteUserToTmTeam from './Auth/InviteMember';
import ManageTeams from './Pages/EmbeddedAnalytics/Analytics/index';
import UploadPBIX from './Pages/EmbeddedAnalytics/UploadPBIX';
import EAReport from './Pages/EmbeddedAnalytics/EAReportPage/EAReport';
import MicrosoftRedirectHandler from '@jumbo/components/Common/authComponents/MicrodoftAuth';
import FormPage from './Pages/FormPage';
import SiteAssessmentPage from './Pages/SiteAssessment';
import SiteContractPage from './Pages/SiteContract';
import DocketsPage from './Pages/Dockets';
import WoodChipSamplePage from './Pages/Woodchip';
import PurchaseRequisitionPage from './Pages/PurchaseReq';
import HfOpsPage from './Pages/HF_Ops';
import TimberSalesPriceForm from './Pages/TimberSalesPricing';
import TimberSalesPricingList from './Pages/TimberSalesPricingList';
import GenTaskPage from './Pages/GenTask';
import ManagingStoresPage from './Pages/ManagingStores';
import GeoFencingPage from './Pages/GeoFencing';
import MapView from './Pages/mapView';
import PeofileManagement from './Pages/ProfileManagement';
import AssignRole from './Pages/ProfileManagement/AssignRoles';
import ManageRole from './Pages/ProfileManagement/ManageRoles';
import MetadataSettings from './Pages/MetadataSettings';
import QuickContract from './Pages/QuickContract';
import EditMetadata from './Pages/EditMetadata';
import AddUserForm from './Pages/ProfileManagement/AddUsers';
import ManageWeighbridge from './Pages/ManageWeighbridge';
import RateCard from './Pages/RateCard';
import UserVersionTrackingView from './Pages/ProfileManagement/ViewDriverAppVersion';
import ChipperLoader from './Pages/ChipperLoader';
import PurchaseRequisition from './Pages/PurchaseRequisition';
import DepartmentMachine from './Pages/DeptsAndMachineSettings';
import LengthChecker from './Pages/LengthChecker';
import Reports from './Pages/Reports';
import ReportViewer from './Pages/Reports/viewer';
import HelpDesk from './Pages/HelpDesk';
import NotificationPage from './Pages/CRM/Notifications';
// import DocketWebForm from './Pages/Dockets/DocketWebForm';
import { Box, Button, CircularProgress, Typography, Paper } from '@material-ui/core';
import { verifyPortalAccess, forceLogout } from './accessControl';
import InboxIcon from '@mui/icons-material/Inbox';

export const NoAccessMessage = () => (
  <Box display="flex" alignItems="center" justifyContent="center" minHeight="70vh">
    <Paper elevation={3} style={{ padding: 24, maxWidth: 420, textAlign: 'center' }}>
      <InboxIcon style={{ fontSize: 64, color: '#c4c9d0', marginBottom: 12 }} />
      <Typography variant="h6" style={{ color: '#111827', fontWeight: 600, marginBottom: 6 }}>
        You don't have the required permission
      </Typography>
      <Typography variant="body2" style={{ color: '#6b7280' }}>
        You are not allowed access to this portal. Please contact your administrator for help.
      </Typography>
    </Paper>
  </Box>
);

const PortalAccessGate = ({ children }) => {
  const [status, setStatus] = useState('checking'); // checking | allowed | denied | error

  const runCheck = async (force = false) => {
    const result = await verifyPortalAccess({ force });
    if (result === 'unauthorized') return forceLogout('session_expired');
    setStatus(result);
  };

  useEffect(() => {
    runCheck();
    const onVisible = () => {
      if (document.visibilityState === 'visible') runCheck(true);
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
    // eslint-disable-next-line
  }, []);

  if (status === 'allowed') return children;
  if (status === 'denied') return <NoAccessMessage />;

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="80vh">
      {status === 'checking' ? (
        <Box />
      ) : (
        <>
          <Typography variant="body2" gutterBottom>
            Couldn't verify your access. Please check your connection.
          </Typography>
          <Button variant="outlined" size="small" onClick={() => { setStatus('checking'); runCheck(true); }}>
            Retry
          </Button>
        </>
      )}
    </Box>
  );
};

const RestrictedRoute = ({ component: Component, ...rest }) => {
  const { authUser } = useSelector(({ auth }) => auth);
  const location = useLocation();
  return (
    <Route
      {...rest}
      render={props =>
        authUser ? (
          <PortalAccessGate>
            <Component {...props} />
          </PortalAccessGate>
        ) : location.pathname == '/oauth-redirect' ? (
          <Redirect to={'/oauth-redirect'} />
        ) : (
          <Redirect to={{ pathname: '/signin', state: { from: props.location } }} />
        )
      }
    />
  );
};

const Routes = () => {
  const { authUser } = useSelector(({ auth }) => auth);
  const location = useLocation();
  const history = useHistory();

  // useEffect(() => {
  //   const token = JSON.parse(localStorage.getItem('token'));
  //   if (token) {
  //     const getexpireDate = token['.expires'];
  //     let expireDate = moment.utc(getexpireDate).toDate();
  //     // Thu Feb 09 2023 13:42:19 GMT+0530
  //     const currentTime = moment(expireDate).format('YYYY-MM-DD HH:mm:ss z');
  //     let newCurrentDate = moment().format('YYYY-MM-DD HH:mm:ss z');
  //     if (currentTime > newCurrentDate) {
  //     } else {
  //       localStorage.removeItem('token');
  //       localStorage.removeItem('user');
  //       localStorage.clear();
  //     }
  //   } else {
  //   }
  // }, []);
  // else if (location.pathname == '/oauth-redirect') {
  //   return <Redirect to={'/oauth-redirect'} />;
  // }

  if (location.pathname === '' || location.pathname === '/') {
    return <Redirect to={'/signin'} />;
  } else if (
    authUser &&
    (location.pathname === '/signin' ||
      location.pathname === '/signup' ||
      location.pathname === '/verifyInviteUser' ||
      location.pathname === '/forgot-password' ||
      location.pathname === '/confirm-user' ||
      location.pathname === '/confirm-email' ||
      location.pathname === '/setpassword' ||
      location.pathname === '/reset-password' ||
      location.pathname == '/oauth-redirect')
  ) {
    return <Redirect to={'/dashboard-page'} />;
  }

  return (
    <div>
      <Switch>
        <RestrictedRoute path="/dashboard-page" component={DashboardPage} />

        <Route path="/embedded-analytics/report/:creditionals" component={EAReport} />

        <RestrictedRoute path="/microsoft/authentication" component={MicrosoftPage} />
        <RestrictedRoute path="/crm/contactsOverview-page" component={ContactsOverview} />
        <RestrictedRoute path="/embedded-analytics/manage-teams" component={ManageTeams} />
        <RestrictedRoute path="/embedded-analytics/view-reports" component={UploadPBIX} />
        <RestrictedRoute path="/my-account/change-password" component={ChangePassword} />
        <RestrictedRoute path="/forms" component={FormPage} />
        <RestrictedRoute path="/siteAssessment" component={SiteAssessmentPage} />
        <RestrictedRoute path="/siteContracts" component={SiteContractPage} />
        <RestrictedRoute path="/dockets" component={DocketsPage} />
        <RestrictedRoute path="/chipper-loader" component={ChipperLoader} />
        <RestrictedRoute path="/woodchipSamples" component={WoodChipSamplePage} />
        <RestrictedRoute path="/purchaseRequisition" component={PurchaseRequisition} />
        <RestrictedRoute path="/timberSalesPricing/:siteAssessmentId?/:pricingVersion?" component={TimberSalesPriceForm} />
        <RestrictedRoute path="/timberSalesPricingList" component={TimberSalesPricingList} />
        <RestrictedRoute path="/hfOps" component={HfOpsPage} />
        <RestrictedRoute path="/generalTask" component={GenTaskPage} />
        <RestrictedRoute path="/managingStores" component={ManagingStoresPage} />
        <RestrictedRoute path="/geofencing" component={GeoFencingPage} />
        <RestrictedRoute path="/mapView" component={MapView} />
        <RestrictedRoute path="/rateCard" component={RateCard} />
        <RestrictedRoute path="/profileManagement" component={PeofileManagement} />
        <RestrictedRoute path="/assignRole" component={AssignRole} />
        <RestrictedRoute path="/manageRole" component={ManageRole} />
        <RestrictedRoute path="/metadataSettings" component={MetadataSettings} />
        <RestrictedRoute path="/manageWeighbridge" component={ManageWeighbridge} />
        <RestrictedRoute path="/notifications" component={NotificationPage} />
        <RestrictedRoute path="/quickContract" component={QuickContract} />
        <RestrictedRoute path="/editMetadata" component={EditMetadata} />
        <RestrictedRoute path="/editDepartmentAndMachines" component={DepartmentMachine} />
        <RestrictedRoute path="/addUser" component={AddUserForm} />
        <RestrictedRoute path="/viewAppVersion" component={UserVersionTrackingView} />
        <RestrictedRoute path="/lengthChecker" component={LengthChecker} />
        <RestrictedRoute exact path="/powerBIReports" component={Reports} />
        <RestrictedRoute path="/powerBIReports/:reportId" component={ReportViewer} />
        <RestrictedRoute path={"/helpdesk"} component={HelpDesk} />

        <Route path="/signin" component={Login} />
        <Route path="/confirm-user" component={ConfirmVerifyEmail} />
        <Route path="/confirm" component={ConfirmUserEmail} />
        <Route path="/verifyInviteUser" component={InviteUserToTmTeam} />
        <Route path="/signup" component={Register} />
        <Route path="/forgot-password" component={ForgotPasswordPage} />
        <Route path="/setpassword" component={NewSetPasswordPage} />
        {/* <Route path="/setpassword/:token" component={NewSetPasswordPage} /> */}
        <Route path="/reset-password" component={ResetPasswordPage} />
        <Route path="/reset-password/:token" component={ResetPasswordPage} />
        {/* <Route path="/docket-form" component={DocketWebForm} /> */}
        <Route path="/oauth-redirect" component={MicrosoftRedirectHandler} />
        <Route component={Error404} />
      </Switch>
    </div>
  );
};

export default Routes;
